







































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'Terms',
})
export default class Terms extends Vue {}
